import classNames from "classnames";
import { LoadingSpinner } from "PFComponents/loading_spinner";
import { Typography } from "PFComponents/typography";
import React, { useEffect, useState } from "react";

import css from "./counter.module.scss";

type CounterClasses = {
  button?: string;
  title?: string;
  number?: string;
};

export type CounterProps = {
  title: string;
  code: string;
  selected: boolean;
  counter?: number | null;
  fetchCounter?: (code: string) => Promise<any>;
  onClick: (code: string) => void;
  disableIfZero?: boolean;
  qaIdPrefix?: string;
  classes?: CounterClasses;
};

export const Counter = ({
  title,
  code,
  selected,
  counter = null,
  disableIfZero = true,
  fetchCounter,
  onClick,
  qaIdPrefix,
  classes
}: CounterProps) => {
  const [fetchedCounter, setFetchedCounter] = useState(null);
  const [loading, setLoading] = useState(counter === null);
  const [fetching, setFetching] = useState(!!fetchCounter);

  useEffect(() => {
    if (!fetchCounter) {
      return;
    }

    setFetching(true);
    fetchCounter(code).then((response) => {
      setFetchedCounter(response.meta.total);
      setFetching(false);
    });
  }, [code, fetchCounter]);

  const handleClick = () => onClick(code);

  useEffect(() => {
    setLoading(counter === null);
  }, [counter]);

  return (
    <button
      className={classNames(css.button, { [css.active]: selected }, classes?.button)}
      onClick={handleClick}
      disabled={disableIfZero && counter === 0}
      data-qa-id={qaIdPrefix ? `${qaIdPrefix}.${code}` : null}
    >
      <Typography variant="bodyRegular" className={classNames(css.title, classes?.title)} noMargin>
        {title}
      </Typography>
      <Typography variant="h4" noMargin className={classNames(css.number, classes?.number)}>
        {fetchCounter ? (
          fetching ? (
            <LoadingSpinner style={{}} />
          ) : (
            fetchedCounter
          )
        ) : loading ? (
          <LoadingSpinner style={{}} />
        ) : (
          counter
        )}
      </Typography>
    </button>
  );
};
